<template>
	<div v-if="data" class="invite_wrap">
		<div class="basic_wrap">
			<!-- <div class="red_top_bg">
				<div class="back_left" @click="$router.back()"></div>
				<div class="big_tit">{{$t('shopd.grabbing')}}</div>
			</div> -->
			<div class="trade" style="padding-bottom: 80px;">
			    <div role="alert" class="van-notice-bar" style="color: rgb(51, 51, 51); background: rgb(250, 250, 250);">
					<i class="van-badge__wrapper van-icon van-icon-volume-o van-notice-bar__left-icon">
			            </i>
					<van-swipe style="padding-right: 1em;height: 1.8em;text-align: right;" :show-indicators="false" autoplay="1500"  :vertical="true">
					  <van-swipe-item v-for="i in cashes" style="line-height: 1.8em;font-size: 1em;" :key="i.id">
						 User[{{i.acc}}] withdraw ${{i.money}} today
					  </van-swipe-item>
					</van-swipe>
			    </div>
			    <div class="usdt-box">
			        <div class="name"><img
			                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKLSURBVHgB7ZhfcpswEMY/ifg9vYGPYN/APUHduJ3pW8gNnBPUPUFygyTPnU65Qehr/wzOCUpPUJ7jWNsVxFPASEIJOJmMfzPYWIvYD+2uJAzs2fO0CHQEJdNDKBnyaQapYjGOUnTAAbqCgnNIHBc/gpg/XqMDJLpjYjh/FFsC6ft0RD+mE/giEJd+LeEJ/ZxO9VFvrwik5OgjBkGCg+A6P/fRN/4S8h1OoOgUWHuFl32dIQi+6oOS2YVRILuZl84X8HLyYch9jiHFG3hT9ouwbKmHuBQaSuEDrRYoco8P6TX6TPz/PvStbKgJHJyAcAVSV4BqHaZ89MSmgjViTsm7CVoz0KnxKU8PoSp5KJodzvRFnAsUsdBTntMyWAXOfvPXsNaact+xrW8+d4Jzrxj5t5zHUf2a5mlG0Yg/ubMI+ZKEbzSE0UleTA12MbSFushZLsjNlFT4RDuBEmnNEVf1+1GzE1sx6VA39dNtq2uUH4zUsllKIyquORpyW0K/jubV9tyJA3VRFTfjXFVVcZpgkKKtwPt1dDt3pDjbzI/m0G4x4gdblPpcIk+fus/PjSNo3Czwk+r8GBmsl0V+tia77zM32JdcIOMmg3ktJtwYbX7iNIcWcdrXH5PJIpC819MHQxSbTBaBIsWukNI4GGaBwXp3I4i71GSx7qi5UP6ioeI6JuMCeWUyujas/Y8i0Y3NbBeolLVzJziK0S5Qih3kob0YHSEO+hdoqeDcDCurFL1z93CB+V7OMst3QObaa7Z57ewvzI4K1rgF9rnktbh3q78+ilcA6mHCVpErxM8ex1LHW3p1G6JPpDq3jaLjz6PbCU/Wvu+4fqzzIoxMZmcO9pd/G15AHu550fwDiGn4MCfbZZMAAAAASUVORK5CYII="
			                    alt=""><span>{{$t('investdetail.accba')}}</span></div>
			        <div class="balance">
						<span class="num">
						{{data.user.money}} 
						</span>
						<span class="unit">USDT</span>
					</div>
			       <!-- <div class="balance-box">
			            <div class="left">
			                <div class="title">Frozen amount</div>
			                <span class="num">0.00</span><span class="unit">USDT</span></div>
			            <div class="right">
			                <div class="title">To recharge amount</div>
			                <span class="num">0.00</span><span class="unit">USDT</span></div>
			        </div> -->
			    </div>
			    <div class="trade-box"><img src="../images/login/frame.png" alt=""
			                                class="name-img">
			        <div class="scroll" >
			            <div  :style="scrollStyle" style="width: 6000px; transform: translate(0px, 0px); transition: all 0ms ease-in 0s; overflow: hidden; display: block;">
			                <div  style="float: left; overflow: hidden; display: block; flex-shrink: 1;">
			                    <div class="list" >
			                        <div class="item" v-for="(item, index) in curlist" :key="index">
			                            <div class="img-box">
											<img :src="item.img"
			                                        alt=""></div>
			                            <div class="name">{{item.title}}</div>
			                            <div class="price">{{item.price}}</div>
			                        </div>
			                    </div>
			                </div>
							<div  style="float: left; overflow: hidden; display: block; flex-shrink: 1;">
							    <div class="list" >
							        <div class="item" v-for="(item, index) in curlist" :key="index">
							            <div class="img-box">
											<img :src="item.img"
							                        alt=""></div>
							            <div class="name">{{item.title}}</div>
							            <div class="price">{{item.price}}</div>
							        </div>
							    </div>
							</div>
			            </div>
			        </div>
			        <div class="btn-box">
			            <button type="button" @click="grap()" class="van-button van-button--default van-button--normal btn"
			                    style="color: white; background: rgb(238, 38, 77); border-color: rgb(238, 38, 77);">
			                <div class="van-button__content">
								<span class="van-button__text">
								{{$t('shopd.graporder')}}
								</span>
			                </div>
			            </button>
			        </div>
			    </div>
			    <div class="list-box">
			        <div class="line top">
						<span>{{$t('shopds.tasksnum')}}</span>
						<span>{{$t('shopds.qcompleted')}}</span>
					</div>
			        <div class="line center">
						<span class="num">{{tong.anum}}</span>
						<span class="num">{{tong.tnum}}</span>
					</div>
			        <div class="line">
						<span>{{$t('shopds.dayincome')}}</span>
						<span class="num">{{tong.tfee}}<span>USDT</span></span>
					</div>
			        <div class="line">
						<span>{{$t('shopds.allimcome')}}</span>
						<span class="num">{{tong.allfee}}<span>USDT</span></span>
					</div>
			    </div>
			</div>
			<!-- 
			<div class="user_money">
				<div class="money_num">
					<div>
						<img src="../images/user/recharge1.png" alt="">
						<p style="font-weight: bold; font-size: 17px; margin: 0px 5px;">
							{{data.user.money}} 
						</p>
						<span>USDT</span>
					</div>
					<div style="font-size:1.3em;font-weight: bold;">{{$t('invest.availableBalance')}}</div>
				</div>
				<div class="user_but">
					<div class="but_click but1" @click="$router.push('/cash')">
					{{$t('user.withdraw')}}
					</div>
					<div class="but_click but2" @click="$router.push('/invest')">
					{{$t('moneybag.recharge')}}
					</div>
				</div>
			</div>
			<div class="capital_title">
			    <div class="capital_text">
			        <span>{{$t('shopds.presentation')}}</span>
			        <p>{{$t('shopds.presentationdetail')}}</p></div>
			    <div class="capital_fun">
			        <div><p>{{$t('shopds.tasksnum')}}</p>
			            <p>{{tong.anum}}</p></div>
			        <div><p>{{$t('shopds.qcompleted')}}</p>
			            <p>{{tong.tnum}}</p></div>
			    </div>
			    <div class="nopermit">
			    	<div class="basic_btn" @click="grap()" >{{$t('shopd.graporder')}}</div>
			    </div>
			    <div class="capital_result">
					<div>
					   <img src="../images/home/shouyi2.png" alt="">
					    <p>{{$t('shopds.dayincome')}}:</p>
					    <p style="color: rgb(255, 83, 83);">{{tong.tfee}} USDT</p></div>
			        <div>
						<img src="../images/home/shouyi3.png" alt="">
			            <p>{{$t('shopds.allimcome')}}:</p>
			            <p style="color: rgb(255, 83, 83);">{{tong.allfee}} USDT</p></div>
			    </div>
			</div> -->
			<van-overlay :show="show3" @click="show3 = false;show=true;">
			  <div class="wrapper1">
				<img src="../images/shop2/cog.png" style="width: 90vw;position: fixed;left: 5%;top: 20vh;" >
			  </div>
			</van-overlay>
			
			<van-overlay :show="show1" @click="show1 = false" >
			  <div class="wrapper1" @click.stop style="height: 100%;100vw;">
				  <div class="block">
					<van-circle
					  v-model:current-rate="currentRate"
					  :stroke-width="60"
					  rate="0"
					  size="100%"
					  :color="gradientColor"
					  :text="$t('shopd.graping')"
					/>
				</div>
			  </div>
			</van-overlay>
			
			<van-overlay :show="show" @click="show = false">
			  <div class="wrapper" @click.stop>
			    <div class="pop_box" v-if="order">
			        <div class="order_cards" >
			            <div  class="order_list1" >
			                <div  class="list_top1">
			                    <img :src="order.pic">
			                    <div  class="list_text1">
			                        <span>{{order.title}}</span>
			                        <div>
			                            <p >{{order.price}}</p>
			                            <p >X1</p>
			                        </div>
			                    </div>
			                </div>
			                <div  class="list_down1">
			                    <div  class="list_down">
			            			<div >
			            			    <span>{{$t('shopds.onum')}}</span>
			            			    <span>{{order.no}}</span>
			            			</div>
			                        <div >
			                            <span>{{$t('shopds.money')}}</span>
			                            <span>{{order.price}}</span>
			                        </div>
									<div >
									    <span>{{$t('shopds.needba')}}</span>
									    <span>{{(1*data.user.money-1*order.price).toFixed(2)}}</span>
									</div>
			                        <div >
			                            <span>{{$t('shopds.income')}}</span>
			                            <span  style="color: rgb(255, 83, 83);">{{order.fee}}</span>
			                        </div>
			                        <div >
			                            <span>{{$t('shopds.numtask')}}</span>
			                            <span>{{order.level}}</span>
			                        </div>
			                        <div >
			                            <span>{{$t('shopds.time')}}</span>
			                            <span>{{order.ct}}</span>
			                        </div>
			                    </div>
			                </div>
			            </div>
			        </div>
			    	<div class="capital_evaluate">
			    		<span>{{$t('shopds.score')}}</span>
			    		<van-rate v-model="star" clearable />
						<span v-if="conf"><img src="../images/shop2/cog.png" style="height: 5vh;margin-left: 5%;" ></span>
			    	</div>
			    	<div class="pop_but"  @click="doorder()">
			    	    <span><span>{{$t('shopds.deal')}}</span></span>
			    	</div>
			    	<div class="pop_but second" @click="show = false">
			    	    <span><span>{{$t('shopd.cancelbtn')}}</span></span>
			    	</div>
			    </div>
			  </div>
			</van-overlay>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue';
	import Vue from 'vue';
	import {
		Swipe,
		SwipeItem,
		Empty,
		Dialog,
		Overlay,
		Circle,
		Icon,Rate
	} from 'vant';
	import Clipboard from "v-clipboard";
	// import { random } from 'core-js/fn/number';
	Vue.use(Empty).use(Clipboard).use(Icon).use(Dialog).use(Overlay).use(Circle).use(Rate);
	export default {
		name: "grap",
		data() {
			return {
				show1:false,
				conf:false,
				data:null,
				tong:null,
				order:null,
				cashes:null,
				show3:false,
				show:false,
				intervalId:null,
				star:0,
				curlist:null,
				translateX: 0,
				currentRate:0,
				gradientColor:{
					'0%': '#FFF500',
					'100%': '#FF00B8'
				},
				vip:null,
				vips:null
			};
		},
		computed: {
			scrollStyle() {
			  return {
				transform: `translate(${this.translateX}px, 0px)`,
				transition: 'transform 0.5s ease' // 可以根据需要调整过渡效果
			  };
			}
		},
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
			bsHeader
		},
		created() {
			this.$parent.footer('grap');
		},
		mounted() {
			this.start();
			this.$nextTick(() => {
				setTimeout(() => {
				  this.startAnimation();
				},200);
			});
		},
		// beforeDestroy() {
		// 	clearInterval(this.intervalId); // 组件销毁前清除定时器
		// },
		methods: {
			startAnimation() {
			  this.intervalId = setInterval(() => {
				  this.translateX -= 190;
				  if(this.translateX<-2850){
					 this.translateX=0;
				  }
				// // 计算滚动距离
				// const scrossElement = this.$refs.scross;
				// scrossElement.style.transition = 'left 2s';
				// scrossElement.style.left = this.len * -172 + 'px';
				
				// // 动画结束后进行克隆和追加
				// setTimeout(() => {
				//   this.len++;
				//   const randomIndex = Math.floor(Math.random() * this.curlist.length);
				//   const newItem = this.curlist[randomIndex];
				//   this.curlist.push(newItem); // 添加新项
				// }, 2000);
			  }, 2000);
			},
			doorder(){
				if(this.star<3){
					this.$toast({
						duration:'3000',
						background: '#07c160',
						message: this.$t('shopds.lowscore')
					});
					return false;
				}
				Fetch("/user/doorder", {
				  id: this.data.id
				}).then(r => {
					// showDialog({
					//   message: this.$t('shopd.corder'),
					//   theme: 'round-button',
					// }).then(() => {
					//   this.$router.push('/grap');
					// });
					this.show = false;
					this.$toast({
						duration:'2000',
						background: '#07c160',
						message: this.$t('shopd.corder')
					});
					this.start();
				}).catch(err=>{
					if(err && err.code==0 && err.data && err.data.need){
						Dialog.confirm({
							title: 'Tips',
							confirmButtonText:this.$t('moneybag.recharge'),
							cancelButtonText:this.$t('shopd.cancelbtn'),
							message: this.$t('shopds.need') + " " +this.utils_moneyMark()+ err.data.need.toFixed(2)
						})
						.then(() => {
						  this.$router.push('/invest');
						})
						.catch(() => {
						});
					}
				})
			},
			grapdata(){
				Fetch('/user/grap').then((r) => {
					// if(r.data=='noaddress'){
					// 	this.$toast({
					// 		background: '#07c160',
					// 		message: this.$t('shopd.setaddr')
					// 	});
					// 	this.$router.push('/addr');
					// }else{
						if(r.data){
							this.order=r.data;
							this.star=0;
							
							// showDialog({
							//   message: this.$t('shopd.lorder'),
							//   theme: 'round-button',
							// }).then(() => {
							//   this.$router.push('/ordering');
							// });
							if(this.order['islucky']){
								this.$toast({
									duration:'5000',
									background: '#07c160',
									message: this.$t('shopd.lorder')
								});
								this.conf =true;
								this.show3=true;
							}else{
								this.show=true;
							}
							
							// this.$router.push('/ordering');
						}else{
							this.$router.push('/ordering');
						}
					// }
				});
			},
			grap(){
				this.show1 = true;
				this.conf =false;
				var randomInt = Math.floor(Math.random() * 50) + 20;
				this.currentRate = 0;
				this.graptime(randomInt);
				// this.grapdata();
			},
			graptime(randomInt){
				this.currentRate += randomInt;
				if(this.currentRate<100){
					setTimeout(() => {
						this.graptime(randomInt);
					}, 1000);
				}else{
					this.show1 = false;
					this.grapdata();
				}
			},
			upvip(it){
				this.$router.push('/invest');
				// if(this.vip){
				// 	if(this.vip.no < it.no){
				// 		Dialog.confirm({
				// 			title: this.$t('shopd.suretitle'),
				// 			confirmButtonText: this.$t('shopd.surebtn'),
				// 			cancelButtonText: this.$t('shopd.cancelbtn'),
				// 			message: this.$t('shopd.surec1')+it.price+ this.$t('shopd.surec2')+it.no+'?'
				// 		}).then(() => {
				// 		    Fetch('/user/upvip', {
				// 		      vip: it.id
				// 		    }).then((r) => {
				// 				if(r.code==1){
				// 					this.$router.push('/user');
				// 				}else{
				// 					this.$router.push('/invest');
				// 				}
				// 		    });
				// 		}).catch(() => {
						    
				// 		});
				// 	}
				// }else{
				// 	this.$router.push('/invest');
				// }
			},
			start() {
				Fetch("/user/basicinfo").then((r) => {
					this.data = r.data;
					this.tong = r.data.tong;
					this.cashes = r.data.cashes;
					this.vip = r.data.vip;
					this.curlist = r.data.pros;
					this.vips = r.data.vips;
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		height: 44px;
		// background: url(../images/user/tg_bg.png) no-repeat center center;
		background-size: 100% 100%;
		position: relative;
		.big_tit {
			position: absolute;
		}
		.back_right{
			position: absolute;
			top: 3px;
			right: 3px;
		}
		
		.introduce {
		    height: 25px;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 18px;
		    line-height: 25px;
		    color: #FFFFFF;
		    margin-top: 20px;
		
		    .line {
		        width: 36px;
		        height: 10px;
		    }
		
		    .tit {
		        margin: 0 12px;
		        font-weight: bold;
		    }
		
		    .left_line {
		        background: url(../images/user/left_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		
		    .right_line {
		        background: url(../images/user/right_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		}
		.award_tip {
		    font-size: 14px;
		    line-height: 20px;
		    color: rgba(255, 255, 255, 0.8);
		    text-align: left;
		    margin: 3px auto 0 auto;
			margin-left: 15%;
		}
	}
	.user_top{
		width: 96%;
		position: relative;
		background: #ee264d;;
		left: 2%;
		border-radius: 5px;
		padding: 15px 0;
		padding-bottom: 5px;
		color: #FFF;
		.user_detail{
			display: flex;
			justify-content: space-between;
			text-align: center;
			.user_header {
				width: 70px;
				height: 70px;
				overflow: hidden;
				border-radius: 50%;
				position: absolute;
				top: -35px;
				img {
					width: 100%;
					height: 100%;
				}
			}
			span{
				margin-left: 80px;
				font-size: 16px;
				font-weight: bold;
			}
		}
		.user_balance{
			text-align: center;
			p:nth-child(1){
				font-size: 4.5vw;
			}
			p:nth-child(2){
				margin-top: 10px;
				font-weight: bold;
				font-size: 18px;
				color: #FF0000;
			}
		}
		.user_team{
			display: flex;
			justify-content: space-between;
			text-align: center;
			p{
				width: 50%;
				margin-top: 20px;
				font-size: 14px;
			}
			p:nth-child(1){
				border-right: 1px #999 solid;
			}
			span{
				color: #FF0000;
				font-weight: bold;
			}
			
		}
		.user_share{
			display: flex;
			justify-content: space-between;
			margin: 20px 0 0px 0;
			font-size: 14px;
			p:nth-child(1){
				width: 70%;
				margin-left: 20px;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
				line-height: 28px;
			}
			p:nth-child(2){
				text-align: center;
				width: 20%;
				background: #e7544d;
				color: #FFFFFF;
				padding: 6px 0px;
				border-radius: 5px;
				margin-right: 15px;
			}
		}
	}
	.tabs{
		display: flex;
		justify-content: space-between;
		text-align: center;
		margin-top: -70px;
		width: 88%;
		margin-left: 6%;
		p{
			width: 28%;
			padding: 5px;
			border-radius: 5px;
		}
		.active{
			background: #f61a44;
			color: #FFFFFF;
		}
	}
	
	.mask {
	    position: fixed;
	    top: 0;
	    right: 0;
	    left: 0;
	    bottom: 0;
	    background-color: rgba(0, 0, 0, 0.6);
	    z-index: 30;
	
	    .share_inner {
	        width: 230px;
			height: 280px;
	        position: absolute;
	        top: 60%;
	        left: 0;
	        right: 0;
	        margin: -232px auto 0 auto;
	        background: url(../images/user/share_bg.png) no-repeat center center;
	        background-size: 100% 100%;
			.earn{
				font-size: 32px;
				position: absolute;
				top: 112px;
				color: #fff;
				font-weight: bold;
				width: 100%;
				text-align: center;
			}
			.invite{
				font-size: 20px;
				position: absolute;
				top: 158px;
				color: #fff;
				width: 100%;
				text-align: center;
			}
			
	    }
	
	    .white_bg {
	        width: 160px;
			height: 160px;
	        background-color: #FFFFFF;
	        position: absolute;
	        top: 30px;
			left: 35px;
	        display: flex;
	        justify-content: center;
	        align-items: center;
	
	        img {
	            width: 143px;
	            height: 143px;
	        }
	    }
	
	    .basic_btn {
	        position: absolute;
	        left: 0;
	        right: 0;
	        margin: 0 auto;
	        top: 175px;
			height: 40px;
			line-height: 40px;
			font-size: 12px;
			width: 90%;
	    }
	}
	.nopermit{
		text-align: center;
		font-size: 12px;
		line-height: 25px;
		margin: 3vw auto;
		p{
			display: flex;
			a{
				text-decoration: none;
				width: 100%;
				text-align: center;
				.basic_btn{
					width: 80%;
					margin: 0 auto;
					height: 12vw;
					font-size: 1.3em;
					line-height: 12vw;
				}
			}
		}
	}
	.scrollBox {
		width: 96%;
		margin-left: 2%;
		position: relative;
	}
	.head-tabs {
	    height: 50px;
	    padding: 15px;
	    background: #fff;
	    white-space: nowrap;
		border-radius: 10px;
		margin: 10px;
		.tab-item {
		    z-index: 0;
		    position: relative;
		    height: 16px;
		    line-height: 16px;
		    font-size: 14px;
		    color: #ababab;
		    transition: all .3s ease;
		}
		.tab-item:after {
		    z-index: -1;
		    content: "";
		    position: absolute;
		    left: 0;
		    right: 0;
		    bottom: 0;
		    height: 4px;
		    border-radius: 2px;
			
		}
		.active {
		    font-size: 1.5em;
		    color: #282828;
			:after {
			    background: #ff8c46;
			}
		}
		.tab-item.active:after {
		    background: #ff8c46;
		}
		.tab-item+.tab-item {
		    margin-left: 20px;
		}
	}
	.table-wrap {
	    position: relative;
	    overflow: hidden;
		margin: 10px;
		border-radius: 10px;
	}
	.ui-table {
	    margin-bottom: -1px;
	    background: #fff7f1;
	}
	.ui-table {
	    background: #fff;
	    font-size: 12px;
	}
	.ui-table {
	    width: 100%;
	    border-collapse: collapse;
	    border-spacing: 0;
	    text-align: center;
		th {
		    height: 40px;
		    background: #ffeee2;
		    font-size: 14px;
		    color: #6c3b23;
		    text-align: center;
			font-weight: 400;
		}
		 .pl {
		    padding-left: 15px;
		}
		td {
		    height: 40px;
		    color: #6d6d6d;
		    border-bottom: 1px solid #ffe8de;
		    text-align: center;
		}
	}
	.vip-item {
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: justify;
	    -webkit-justify-content: space-between;
	    -ms-flex-pack: justify;
	    justify-content: space-between;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	    padding: 2vw 3vw;
	    box-sizing: border-box;
	    border-radius: 8px;
	    background-color: #fff;
	    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
	    margin-bottom: 12px;
	    position: relative;
	    overflow: hidden;
	}
	.vip-item .vip-img {
	    width: 20vw;
	    height: 20vw;
	}
	.vip-item .vip-info {
	    text-align: left;
		width: 50vw;
	}
	.vip-item .vip-info .vip-name {
	    font-size: 3.8vw;
	    font-weight: bold;
	    color: #222;
		margin-bottom: 1vw;
		margin-top: 8vw;
	}
	.vip-item .vip-info .vip-desc {
		font-size: 3vw;
		font-weight: bold;
		color: #999;
		line-height: 1.5em;
	}
	.vip-item .action-box .ord{
		font-size: 2vw;
		font-weight: bold;
		line-height: 6vw;
		color: rgb(74, 193, 171);
	}
	.vip-item .action-box .i-icon {
	    padding: 2vw 3vw;
	    text-align: center;
	    background-color: #ee264d;;
	    font-size: 14px;
	    color:#fff;
	    border-radius: 1.5em;
	    cursor: pointer;
	}
	
	.vip-item .absoulte-level {
	    position: absolute;
	    background: #f5f5f5;
	    color: #ee264d;;
	    padding: 24px 16px 8px 16px;
	    border-radius: 50%;
	    top: -20px;
	    left: 50%;
	    font-size: 12px;
	}
	.vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	.vip-item .mask {
	    position: absolute;
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    background: rgba(0,0,0,.4);
	    border-radius: 8px;
	    z-index: 2;
	}
	
	.vip-item .mask .lock-box,.index-wrap2 .vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	
	.vip-item .mask .lock-box {
	    background: hsla(0,0%,100%,.4);
	    width: 50px;
	    height: 50px;
	    border-radius: 50%;
	}
	.vip-item .mask .lock-box, .index-wrap2 .vip-item .mask{
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
	}
	
	.stat {
	    width: 100%;
	    padding:  0;
		color: #FFF;
		.item {
		    display: flex;
		    flex-direction: row;
		    justify-content: flex-start;
		    margin: 0 ;
			.item-left {
			    flex: 1;
			    margin: 2vw;
			    border-radius: 2vw;
			    padding: 2vw;
			    text-align: center;
			    background-color:#ee264d;
				color: #000;
				.title {
				    line-height: 20px;
					font-size: 12px;
					font-weight: 500;
				}
				.value {
				    line-height: 40px;
				    font-size: 24px;
				    font-weight: bold;
				}
			}
		}
	}
	.basic_btn{
		margin: 0 auto;
	}
	/deep/ .van-circle__text{
		color: #FFF;
	}
	.wrapper1 {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	  }
	
	.block {
	    width: 150px;
	    height: 150px;
	}
	.user_money{
		display: block;
	    width: 90%;
	    margin-left: 5%;
	    background-color: #fff;
	    border-radius: 10px;
	    padding: 15px;
	    margin-top: 2vh;
	    background: url(../images/user/smallBackground.png) no-repeat;
	    background-size: cover;
	    background-position: 50%;
		.money_num{
		    width: auto;
		    height: 40px;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    font-size: 12px;
		    margin-bottom: 4%;
			>div:first-child {
			    display: flex;
			    align-items: center;
				img{
				    width: 20px;
				    height: 20px;
					display: inline-block;
					overflow: hidden;
					position: relative;
				}
				p{
					font-weight: bold;
					color: #000000e6;
					font-size: 17px;
					margin: 0px 5px;
				}
			}
		}
		.user_but{
		    display: flex;
		    justify-content: space-around;
		    align-items: center;
			.but_click{
			    width: 45%;
			    height: 40px;
			    border-radius: 10px;
			    display: flex;
			    align-items: center;
			    justify-content: center;
			}
		}
	}
	
	.capital_title{
	    width: 90%;
	    height: auto;
	    background-image: linear-gradient(#ee264d,#fff);
	    padding: 10px;
	    margin: 3% 5%;
	    border-radius: 10px;
		.capital_text{
		    width: 100%;
		    display: flex;
		    justify-content: space-around;
		    flex-direction: column;
		    border-bottom: 1px solid #232f3e;
			font-size: 1.3em;
			line-height: 1.5em;
			p {
			   font-size: 0.9em;
			   margin: 3% 0;
			   line-height: 1.5em;
			}
		}
		.capital_fun{
		    width: 100%;
		    height: 90px;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
			>div{
			    width: 50%;
			    display: flex;
			    align-items: center;
			    justify-content: center;
			    flex-direction: column;
				font-size: 1.1em;
				line-height: 2.3em;
				>p:last-child {
				    color: #232f3e;
				    font-size: 19px;
				    font-weight: 700;
				}
			}
			>div:first-child {
			    border-right: 1px solid #232f3e;
			}
		}
		.capital_result{
		    width: 100%;
		    margin: 5% 0;
		    font-size: 15px;
			>div{
			    display: flex;
			    align-items: center;
				>p:last-child {
				    margin-left: 2%;
				}
			}
			img{
			    width: 30px;
			    height: 30px;
				display: inline-block;
				overflow: hidden;
				position: relative;
			}
		}
	}
	.order_list1{
	    background-color: #fff;
	    padding: 10px;
		margin: 10px;
	    border-radius: 10px;
	    box-shadow: 0 4px 4px rgba(0,0,0,.05);
		.list_top1{
		    width: 100%;
		    height: 90%;
		    border-bottom: 1px dashed gray;
		    display: flex;
		    justify-content: space-between;
		    padding: 5px 0;
			img{
			    max-width: 100px;
			    max-height: 100px;
			    border-radius: 10px;
			}
			.list_text1{
			    width: 60%;
			    display: flex;
			    justify-content: space-between;
			    flex-direction: column;
				> span:first-child {
				    display: block;
				    font-size: 12px;
				    color: #37475a;
				    overflow: hidden;
				    text-overflow: ellipsis;
				    -webkit-line-clamp: 4;
				    display: -webkit-box;
				    -webkit-box-orient: vertical;
					line-height: 1.5em;
				}
				 > div {
				    display: flex;
				    justify-content: space-between;
				    align-items: center;
				    margin: 3% 0;
				    color: #232f3e;
				    font-size: 17px;
				    font-weight: 600;
					> p:last-child {
					    color: #034aff;
					    font-size: 12px;
					}
				}
			}
		}
		.list_down{
		    /* height: 50%; */
		    display: flex;
		    flex-direction: column;
		    justify-content: space-between;
		    font-size: 13px;
		    padding: 5px 0;
			> div{
			    display: flex;
			    justify-content: space-between;
			    align-items: center;
			    color: #37475a;
			    height: 20px;
				> span:last-child {
				    color: #232f3e;
				    font-size: 13px;
				}
			}
		}
		.list_down1{
		    height: auto;
		    text-align: end;
			font-size: 16px;
		}
	}
	.basic_btn{
		margin: 5% auto;
	}
	
	.pop_box{
	    width: 90%;
	    max-width: 600px;
	    padding: 5px;
	    position: relative;
	    border-radius: 10px;
	    background-image: linear-gradient(#000, #ee264d);
		.pop_but{
		    width: 96%;
		    margin: 4% 2%;
		    height: 41px;
		    border-radius: 10px;
		    display: flex;
		    align-items: center;
		    justify-content: center;
		    background-color: #232f3e;
		    color: #ee264d;;
			font-size: 1.3em;
		}
		.capital_evaluate{
			width: 100%;
			height: auto;
			padding: 10px;
			font-size: 1.3em;
			>span{
				margin-right: 3vw;
			}
		}
		.second{
		    background-color: #d9d9d9;
		    color: #37475a;
		}
	}
	.wrapper {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    margin-top: 15vh;
	}
	
	/deep/ .van-overlay{
		position: absolute;
		z-index: 10001;
	}
	.basic_wrap{
		position: relative;
		height: 100vh;
	}
	
	.trade {
	width: 100%;
	min-height: calc(100vh - 1.78667rem);
	background-image: url(../images/login/tradebg.png);
	background-repeat: no-repeat;
	background-position: top center;
	background-size: cover;
	background-attachment: fixed;
	padding: .53333rem
	}
	
	.notice-swipe {
	height: 1.06667rem;
	line-height: 1.06667rem
	}
	
	 .van-notice-bar {
	border-radius: .13333rem;
	background: #fafafa
	}
	
	.usdt-box {
	margin-top: .56rem
	}
	
	.usdt-box .name {
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-webkit-align-items: center;
	-ms-flex-align: center;
	align-items: center;
	color: #d9d9d9;
	font-size: .37333rem;
	font-weight: 500
	}
	
	.usdt-box .name img {
	width: .53333rem;
	margin-right: .13333rem
	}
	
	.usdt-box .balance {
	margin-top: .26667rem
	}
	
	.usdt-box .balance .num {
	color: #fff;
	font-size: .5333rem;
	font-weight: 700;
	margin-right: .10667rem
	}
	
	.usdt-box .balance .unit {
	color: #1aa392;
	font-size: .32667rem;
	font-weight: 500
	}
	
	.usdt-box .balance-box {
	margin-top: .4rem;
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-webkit-justify-content: space-between;
	-ms-flex-pack: justify;
	justify-content: space-between;
	-webkit-box-align: center;
	-webkit-align-items: center;
	-ms-flex-align: center;
	align-items: center
	}
	
	.usdt-box .balance-box div {
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	-ms-flex: 1;
	flex: 1
	}
	
	.usdt-box .balance-box div .title {
	color: #d9d9d9;
	font-size: .37333rem;
	font-weight: 500;
	margin-bottom: .16rem
	}
	
	.usdt-box .balance-box div .num {
	color: #fff;
	font-size: .69333rem;
	font-weight: 700;
	margin-right: .10667rem
	}
	
	.usdt-box .balance-box div .unit {
	color: #1aa392;
	font-size: .42667rem;
	font-weight: 500
	}
	
	.trade-box {
	margin-top: 1.81333rem;
	width: 100%;
	border-radius: .13333rem;
	background: #fafafa;
	position: relative;
	padding-top: 1.2rem;
	padding-bottom: .53333rem;
	background-image: url(../images/login/ppbg.png);
	background-repeat: no-repeat;
	background-position: top center;
	background-size: 100% 100%
	}
	
	.trade-box .name-img {
	width: 2.09333rem;
	height: 2.09333rem;
	position: absolute;
	top: -1.17333rem;
	left: 0;
	right: 0;
	margin: auto
	}
	
	.trade-box .scroll {
	height: 5.2rem;
	width: 100%;
	overflow: hidden
	}
	
	.trade-box .scroll .list {
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex
	}
	
	.trade-box .scroll .list .item {
	-webkit-box-flex: 0;
	-webkit-flex: 0 0 auto;
	-ms-flex: 0 0 auto;
	flex: 0 0 auto;
	width: 170px;
	margin-right: 20px;
	}
	
	.trade-box .scroll .list .item .img-box {
		overflow: hidden;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		border-radius: .13333rem;
		max-height: 160px;
	}
	
	.trade-box .scroll .list .item .img-box img {
	width: 100%
	}
	
	.trade-box .scroll .list .item .name {
	overflow: hidden;
	color: #333;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: .33333rem;
	font-weight: 400;
	margin: .05333rem 0
	}
	
	.trade-box .scroll .list .item .price {
	color: #000;
	font-size: .48rem;
	font-weight: 700;
	text-align: center
	}
	
	.trade-box .btn-box {
		width: 100%;
		padding: 0 .4rem;
		margin-top: .23333rem;
		position: relative;
		z-index: 1000
	}
	
	.trade-box .btn-box .btn {
	width: 100%;
	color: #fafafa;
	font-size: .42667rem;
	font-weight: 700;
	position: relative;
	z-index: 1
	}
	
	.list-box {
	width: 100%;
	border-radius: .26667rem;
	background: #fafafa;
	margin-top: .53333rem;
	overflow: hidden
	}
	
	.list-box .line {
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	line-height: 1.06667rem;
	padding: 0 .32rem;
	border-top: .02667rem solid #000
	}
	
	.list-box .line span {
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	-ms-flex: 1;
	flex: 1;
	color: #000;
	font-size: .37333rem;
	font-weight: 400
	}
	
	.list-box .line span:nth-of-type(2) {
	text-align: right
	}
	
	.list-box .line .num {
	color: #000;
	font-size: .39rem;
	font-weight: 700
	}
	
	.list-box .line .num span {
	color: #1aa392;
	font-size: .32rem;
	font-weight: 700;
	padding-left: 5px;
	}
	
	.list-box .top {
	background: #000;
	border-radius: .26667rem .26667rem 0 0;
	border: .02667rem solid rgba(255,255,255,.2)
	}
	
	.list-box .top span {
	color: #fff;
	font-size: .37333rem;
	font-weight: 400;
	text-align: center!important
	}
	
	.list-box .center {
	border-top: none
	}
	
	.list-box .center span {
	text-align: center!important
	}
</style>
